import React from "react";
import { Briefcase, GraduationCap, Award } from "lucide-react";
import { experience, education, certifications } from "../data/mock";

const Experience = () => {
  return (
    <section id="experience" className="section bg-[#F8F5EE]">
      <div className="max-w-7xl mx-auto container-px">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7 reveal">
            <span className="eyebrow">Journey</span>
            <h2 className="h-section text-3xl lg:text-5xl mt-6">
              Fifteen years across
              <br />
              <span className="italic">clinic, hospital and law.</span>
            </h2>
            <div className="divider-gold" />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Experience timeline */}
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-8">
              <Briefcase size={18} className="text-[#C9A961]" />
              <h3 className="text-[12px] tracking-[0.25em] uppercase text-[#0B1E3F]/70">Experience</h3>
            </div>
            <ol className="relative border-l border-[#0B1E3F]/15 pl-8 space-y-10">
              {experience.map((e, i) => (
                <li key={i} className="relative">
                  <span className="absolute -left-[37px] top-1.5 w-3.5 h-3.5 bg-[#F8F5EE] border-2 border-[#C9A961]" />
                  <div className="text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/55">
                    {e.period}
                  </div>
                  <h4 className="font-serif text-xl text-[#0B1E3F] mt-2">{e.role}</h4>
                  <div className="text-[13px] text-[#C9A961] tracking-wide mt-1">{e.org}</div>
                  <p className="mt-3 text-[14px] text-[#0B1E3F]/75 leading-relaxed">{e.description}</p>
                </li>
              ))}
            </ol>
          </div>

          {/* Education + certs */}
          <div className="lg:col-span-5 space-y-12">
            <div className="reveal">
              <div className="flex items-center gap-3 mb-8">
                <GraduationCap size={18} className="text-[#C9A961]" />
                <h3 className="text-[12px] tracking-[0.25em] uppercase text-[#0B1E3F]/70">Education</h3>
              </div>
              <div className="space-y-6">
                {education.map((ed, i) => (
                  <div key={i} className="p-6 border border-[#0B1E3F]/10 bg-white card-lift">
                    <div className="text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/55">
                      {ed.period}
                    </div>
                    <h4 className="font-serif text-lg text-[#0B1E3F] mt-1">{ed.degree}</h4>
                    <div className="text-[13px] text-[#0B1E3F]/65 mt-1">{ed.school}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="reveal">
              <div className="flex items-center gap-3 mb-6">
                <Award size={18} className="text-[#C9A961]" />
                <h3 className="text-[12px] tracking-[0.25em] uppercase text-[#0B1E3F]/70">Certifications</h3>
              </div>
              <ul className="space-y-3">
                {certifications.map((c, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-[14px] text-[#0B1E3F]/80"
                  >
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#C9A961] flex-shrink-0" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
